import {
  VBtn,
  VBtnToggle,
  VIcon,
  VTooltip,
} from 'vuetify/components'

/**
 * Vuetify components that are required to be registered for these components to work.
 *
 * @example
 * import { vuetifyComponents } from '@policyfly/components'
 *
 * const opts = createVuetifyOptions({
 *   extraComponents: vuetifyComponents(),
 * })
 * export const vuetify = createVuetify(opts)
 */
export function vuetifyComponents (): Record<string, object> {
  return {
    VBtnToggle,
    VTooltip,
    VBtn,
    VIcon,
  }
}
